import React from 'react';
import { BehaviorEventRow } from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/event-row';
import { useBehaviorsList } from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/behaviors-list';
import type { RowProps } from '../catalog';
import styles from './index.module.styl';

/**
 * Renders a behavior definition for specifying multiple event conditions a user can be matched
 * on, this mimics the functionality of custom events.
 */
export function SimpleBehaviorDefinition(props: RowProps) {
  var _props$entry$behavior;
  const hasMultipleEvents = ((_props$entry$behavior = props.entry.behavior.behaviors) !== null && _props$entry$behavior !== void 0 ? _props$entry$behavior : []).length > 1;
  const {
    behaviors,
    handleUpdateBehavior,
    handleDeleteBehavior,
    handleDuplicateBehavior
  } = useBehaviorsList(props.entry, props.updateEntry);
  return <div className={styles.simpleBehavior} data-sentry-component="SimpleBehaviorDefinition" data-sentry-source-file="behavior-definition.tsx">
      {behaviors.map((subBehavior, index) => {
      return <BehaviorEventRow {...props} behavior={subBehavior}
      // @todo(metrics) Figure out a way to uniquely identify each behavior in a metric
      // key={index}
      onDelete={hasMultipleEvents ? () => handleDeleteBehavior(index) : null} onDuplicate={() => handleDuplicateBehavior(index)} onSelect={behavior => handleUpdateBehavior(index, behavior)} suffixLabel={hasMultipleEvents && index !== behaviors.length - 1 ? " or" : null} />;
    })}
    </div>;
}